export default __webpack_public_path__ + "static/needlefilewithdust-6d66cf5030fd243d0a6b776b882ba4f1.png";